import axios from 'axios';
import { MagicXPromo } from './types';
import { getToken } from '../../../utils/auth';
import { xApiKey } from './consts';

const requestUrl = process.env.REACT_APP_MAGIC_X_URL;

export const getAvailablegMxPromotions = async (userName: string | undefined | null): Promise<MagicXPromo[]> => {
  const config = {
    headers: {
      'x-api-key': xApiKey,
    },
  };
  const payload = {
    userName,
  };

  const result = await axios.post(`${requestUrl}/promotions/filter`, payload, config);

  return result?.data?.res;
};

export const getActiveMxPromotions = async (userName: string | undefined | null): Promise<MagicXPromo[]> => {
  const token = getToken();

  const config = {
    headers: {
      authorization: token ? `Bearer ${token}` : null,
      'x-api-key': xApiKey,
    },
  };
  const payload = {
    userName,
  };

  const result = await axios.post(`${requestUrl}/competitions/getAll`, payload, config);

  return result?.data?.res;
};

export const optInMxPromotion = async (
  slug: string | undefined | null,
  cta: string | undefined | null
): Promise<{ name: string; message: string }> => {
  const token = getToken();

  const config = {
    headers: {
      authorization: token ? `Bearer ${token}` : null,
      'x-api-key': xApiKey,
    },
  };
  const payload = {
    slug,
    cta,
    lang: 'gb',
  };

  const result = await axios.post(`${requestUrl}/promotions/optIn`, payload, config);

  return result?.data?.res;
};
